import type { IAgeRatios } from "app/pages/website-analysis/demographicsUserBased/utils/fetchData";
import type { IAgeDistribution } from "app/pages/website-analysis/demographics/types";

export const parseRawAgeRations = (ageRatios: IAgeRatios): IAgeDistribution => {
    if (!ageRatios) {return null;}
    const normalizedAgeRatios = Object.keys(ageRatios).reduce((result, current) => {
        return { ...result, [current]: ageRatios[current] * 100 };
    }, {}) as IAgeRatios;
    return {
        Age18To24: normalizedAgeRatios.Age18To24,
        Age25To34: normalizedAgeRatios.Age25To34,
        Age35To44: normalizedAgeRatios.Age35To44,
        Age45To54: normalizedAgeRatios.Age45To54,
        Age55To64: normalizedAgeRatios.Age55To64,
        Age65Plus: normalizedAgeRatios.Age65,
    };
};
